module.exports = __webpack_public_path__ + "img/5.6ed3837.jpg";